module.exports = __webpack_public_path__ + "static/media/person.25cabb35.svg";